import { render, staticRenderFns } from "./list-projects.vue?vue&type=template&id=266ec917"
import script from "./list-projects.vue?vue&type=script&lang=js"
export * from "./list-projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports